<template>
  <v-card

    class="mx-auto"
  >
    <v-toolbar
      color="teal"
      dark
    >

      <v-toolbar-title>Account Settings</v-toolbar-title>
    </v-toolbar>

   
      <v-subheader >My Donation Form</v-subheader>

      <v-subheader >Your current logo</v-subheader>
      
      <img class='ma-5' width='300' :src='getImg()' />
       <v-file-input
      @change='fileUpload'
      v-model='theFile'
    accept="image/*"
    label="Upoload your logo"
  ></v-file-input>
    <v-btn
    class='ml-5 mb-5'
    :disabled='!theFile'
    @click="uploadDoc()">Upload</v-btn>      
  
      <span></span>

      <v-alert
      border="left"
      colored-border
      color="green"
      elevation="2"
    >Copy the code snippet below and paste it into your webpage's html content.  The width and height can be adjusted by modifying the width and height attribute in the iframe code snippet.

      <br/>
      <code>{{genHTML()}}</code>
    </v-alert>

    
     <h4> see example below : </h4>
      <iframe 
  width="400"
  height="600"
  frameborder="0" style="border:0"
  :src='source()' allowfullscreen>
</iframe>
     
  </v-card>
</template>

<script>
const fb = require("./../../firebaseconfig");
  export default {
    data: () => ({
      theFile : null,
      companyName : null,
      npo : null,
      refurbisher : null,
       logo: null,
    }),
    methods : {
            getImg(){
        return "https://storage.googleapis.com/donorconnection-df169.appspot.com/logos/"+this.npo+".png"
      },
      uploadDoc(){
                 this.$axios.post('https://us-central1-donorconnection-df169.cloudfunctions.net/partnerapi/uploadLogo', {
               base64 : this.logo,
               npoID : this.npo,
               fileType : this.theFile.type
            }, { headers: { "Content-Type": "application/json" } }).then((data) => {
                console.log(data);
            })
      },
      fileUpload(f){
	if (f === null){return;}
      var reader = new FileReader();
	reader.onload = ((theFile) => {
	this.theFile = theFile;
	return (e) => {
      var binaryData = e.target.result;
      this.logo = window.btoa(binaryData);
        };
        })(f);
      reader.readAsBinaryString(f);
      },
      source(){
        return `https://donation.ecycleforgood.com/donation/${this.npo}/${this.refurbisher}`;
      },
      genHTML(){
        return ` <iframe 
  width="100%"
  height="800"
  frameborder="0" style="border:0"
  src="https://donation.ecycleforgood.com/donation/${this.npo}/${this.refurbisher}" allowfullscreen>
</iframe>`
      }
    },
    mounted() {
        fb.auth.currentUser.getIdTokenResult()
  .then((idTokenResult) => {
    this.npo = idTokenResult.claims.npo;
    this.refurbisher = idTokenResult.claims.id;
  })
    },
  }
</script>